import axios from 'axios';

export default {
  getAchievedGoals({ commit, state }, { ctx, filter }) {
    return new Promise((resolve, reject) => {
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/achievedGoals/get`,
        params: { ...ctx, ...filter },
        method: 'GET'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            reject(new Error());
            return;
          }
          commit('insertAchievedGoals', resp.data);
          resolve(resp);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  deleteAchievedGoal({ commit, state }, id) {
    return new Promise((resolve, reject) => {
      commit('deleteAchievedGoalRequestPending');
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/achievedGoals/destroy`,
        params: { id },
        method: 'DELETE'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            reject(new Error());
            return;
          }
          commit('deleteAchievedGoalRequestSuccess');
          resolve(resp);
        })
        .catch(err => {
          commit('deleteAchievedGoalRequestError', err);
          reject(err);
        });
    });
  }
};
